import { fromJS } from 'immutable';
import {
  CLEAN_OPTIONS,
  FETCH_OPTIONS,
  FETCH_OPTIONS_FAILURE,
  FETCH_OPTIONS_SUCCESS,
  SAVE_OPTIONS,
  SAVE_OPTIONS_FAILURE,
  SAVE_OPTIONS_SUCCESS,
} from '@Pages/RetroSynthesis/ProjectParametersDialog/constants';

export const IS_LOADING = 'isLoading';
export const RESPONSE = 'response';
export const VENDORS_INFO = 'vendorsInfo';
const ERROR = 'error';

export const initialState = fromJS({
  [IS_LOADING]: false,
  [RESPONSE]: undefined,
  [VENDORS_INFO]: undefined,
  [ERROR]: undefined,
});

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CLEAN_OPTIONS:
      return state.set(IS_LOADING, false).set(RESPONSE, undefined);
    case FETCH_OPTIONS:
      return state.set(IS_LOADING, true).set(RESPONSE, undefined);
    case FETCH_OPTIONS_SUCCESS:
      return state
        .set(IS_LOADING, false)
        .set(ERROR, undefined)
        .set(RESPONSE, action.payload.response)
        .set(VENDORS_INFO, action.payload.vendorsInfo);
    case FETCH_OPTIONS_FAILURE:
      return state.set(IS_LOADING, false).set(ERROR, action.payload).set(RESPONSE, undefined);
    case SAVE_OPTIONS:
    case SAVE_OPTIONS_SUCCESS:
    case SAVE_OPTIONS_FAILURE:
    default: {
      return state;
    }
  }
}
